import "./SqlContent.scss";
import { useLocation, useParams } from "react-router-dom";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { FaCopy, FaRegCopy } from "react-icons/fa";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Helmet } from "react-helmet";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useContext, useState } from "react";

import SqlLoop from "../SqlLoop/SqlLoop";
import MyContext from "../../../../Uttis/MyContext";

// All course JSON imports
import SQL from "../Json/SqlJson";
import CssJson from "../Json/CssJson";
import CssAJson from "../Json/CssAJson";
import Javas from "../Json/JavasJson";
import CyberJson from "../Json/CyberJson";
import ExcelJson from "../Json/ExcelJson";
import ExpressJson from "../Json/ExpressJson";
import FigmaJson from "../Json/FigmaJson";
import ProjectJson from "../Json/ProjectJson";
import ReactJson from "../Json/ReactJson";
import ReactNativeJson from "../Json/ReactNativeJson";
import HTML from "../Json/HtmlJson";
import TailwindJson from "../Json/TailwindJson";
import PythonJson from "../Json/PythonJson";
import NextJson from "../Json/NextJsJson";
import PhpJson from "../Json/PhpJson";
import LaravelJson from "../Json/Laraveljson";
import DjangoJson from "../Json/DjangoJson";
import MlJson from "../Json/Machine";
import NumpyJson from "../Json/NumpyJson";
import PandasJson from "../Json/PandasJson";
import Scikit from "../Json/ScikitJson";
import StreamlitJson from "../Json/StreamlitJson";
import Computer_Vision from "../Json/Computer_Vision";

const SqlContent = () => {
  const { setCode, setSnack, setMessage } = useContext(MyContext);
  const { title, course } = useParams();
  const location = useLocation();

  // Decide which JSON to use based on course
  const data =
    course === "html" ? HTML :
    course === "sql" ? SQL :
    course === "css" ? CssJson :
    course === "css-advance" ? CssAJson :
    course === "javascript" ? Javas :
    course === "cyber-security" ? CyberJson :
    course === "excel" ? ExcelJson :
    course === "express-js" ? ExpressJson :
    course === "ui-ux" ? FigmaJson :
    course === "project" ? ProjectJson :
    course === "reactjs" ? ReactJson :
    course === "react-native" ? ReactNativeJson :
    course === "tailwindcss" ? TailwindJson :
    course === "python" ? PythonJson :
    course === "nextjs" ? NextJson :
    course === "php" ? PhpJson :
    course === "laravel" ? LaravelJson :
    course === "django" ? DjangoJson :
    course === "machine-learning" ? MlJson :
    course === "numpy" ? NumpyJson :
    course === "pandas" ? PandasJson :
    course === "scikit-learn" ? Scikit :
    course === "streamlit" ? StreamlitJson :
    course === "computer-vision" ? Computer_Vision :
    null;

  const [menuOpen, setMenuOpen] = useState(window.innerWidth > 768);
  const [copied, setCopied] = useState(false);
  const [store, setStore] = useState("");

  const handleRun = (code) => {
    setCode(code);
    window.open("/vxeditor", "_blank");
  };

  const handleCopy = (heading) => {
    setSnack(true);
    setMessage("Copied to clipboard ");
    setCopied(true);
    setStore(heading);
    setTimeout(() => setCopied(false), 500);
  };

  return (
    <>
      <Helmet>
        <title>{`${course} ${title} Tutorial (Solved With Example)`}</title>
        <meta
          name="description"
          content={`V-Ex Tech provides the best ${title} training in Vadodara with job placement. This course covers all key ${course} concepts with solved examples.`}
        />
      </Helmet>

      <div className="sql-main">
        {menuOpen && (
          <aside className="sql-left">
            <SqlLoop course={course} title={title} data={data} />
          </aside>
        )}

        <section className="sql-right">
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <HiOutlineMenuAlt2 />
          </button>

          {data
            ?.filter((item) => item.html_title === title)
            .map((item) =>
              item.bootstrap_head_desc.map((head, index) => (
                <div className="lesson-section" key={index}>
                  <h1 className="lesson-title">{head.bootstrap_title_heading}</h1>
                  
                  <pre className="lesson-code" style={head.style}>
                    <CopyToClipboard
                      text={head.bootstrap_title_desc}
                      onCopy={() => handleCopy(head.bootstrap_title_heading)}
                    >
                      {copied && store === head.bootstrap_title_heading ? (
                        <FaCopy />
                      ) : (
                        <FaRegCopy />
                      )}
                    </CopyToClipboard>
                    {head.bootstrap_title_desc}
                  </pre>

                  {!head.copy && /html|css|javascript|css-advance/.test(course) && (
                    <button className="run-btn" onClick={() => handleRun(head.bootstrap_title_desc)}>
                      Run <MdKeyboardDoubleArrowRight />
                    </button>
                  )}

                  {head.img && <img src={head.img} alt="example" />}
                </div>
              ))
            )}
        </section>
      </div>
    </>
  );
};

export default SqlContent;
